// Hook: loads next-steps action sheet templates from Supabase portal_config table.
// Falls back to the `defaults` passed in (NEXT_STEPS_DEFAULTS).
// TypeScript source — useNextStepsTemplates.js is a thin re-export stub.

import React from "react";
import { getConfigValue } from "../data/portalConfig";

// In-memory cache
var _cachedTemplates: unknown[] | null = null;
var _cacheTime = 0;
var CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export function useNextStepsTemplates(defaults?: unknown[]) {
  var state = React.useState<unknown[]>(_cachedTemplates || defaults || []);
  var templates = state[0];
  var setTemplates = state[1];
  var loaded = React.useState(!!_cachedTemplates);
  var isLoaded = loaded[0];
  var setLoaded = loaded[1];

  React.useEffect(function () {
    if (_cachedTemplates && Date.now() - _cacheTime < CACHE_TTL) {
      setTemplates(_cachedTemplates);
      setLoaded(true);
      return;
    }
    getConfigValue("next_steps_templates").then(function (value) {
      var result: unknown[] = defaults || [];
      if (value && Array.isArray(value) && value.length > 0) {
        result = value;
      }
      _cachedTemplates = result;
      _cacheTime = Date.now();
      setTemplates(result);
      setLoaded(true);
    });
  }, []);

  return { templates: templates, isLoaded: isLoaded };
}

export function invalidateNextStepsCache() {
  _cachedTemplates = null;
  _cacheTime = 0;
}
